import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e0125a3")

_pushScopeId("data-v-7e0125a3")
const _hoisted_1 = {
  class: "all-tickets-claim-waiting",
  id: "all-tickets-claim-waiting"
}
const _hoisted_2 = { class: "ticket-title" }
const _hoisted_3 = {
  key: 0,
  class: "i-task"
}
const _hoisted_4 = {
  key: 1,
  class: "i-working"
}
const _hoisted_5 = {
  key: 2,
  class: "i-aftersale"
}
const _hoisted_6 = {
  key: 3,
  class: "i-test"
}
const _hoisted_7 = {
  key: 0,
  class: "warning"
}
const _hoisted_8 = {
  key: 1,
  class: "timeout"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "operation-btn-wrap" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("指派")
const _hoisted_12 = {
  key: 1,
  class: "batch-btn batch-disabled"
}
const _hoisted_13 = {
  key: 2,
  class: "pagination-wrap"
}
const _hoisted_14 = { class: "person-select-dialog-content" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "batch-ticket-title" }, "批量指派工单", -1)
const _hoisted_16 = { id: "batch-ticket-form" }
const _hoisted_17 = { class: "batch-ticket-top" }
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("指 派")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TicketViewSearchForm = _resolveComponent("TicketViewSearchForm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_PersonSelect = _resolveComponent("PersonSelect")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_EdgePersonSelect = _resolveComponent("EdgePersonSelect")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TicketViewSearchForm, {
      queryForm: _ctx.savedQueryData,
      submit: _ctx.ticketViewSearchFormSubmit
    }, null, 8, ["queryForm", "submit"]),
    _withDirectives(_createVNode(_component_el_table, {
      border: "",
      class: "ticket-table",
      data: _ctx.tableData,
      ref: "ticketTable",
      "row-key": "id",
      style: {"width":"100%"},
      "default-sort": _ctx.orderField,
      onSelectionChange: _ctx.handleSelectionChange,
      onSortChange: _ctx.sortChange
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          selectable: (r) => r.curPhaseId,
          width: "40"
        }, null, 8, ["selectable"]),
        _createVNode(_component_el_table_column, {
          prop: "id",
          width: "80",
          label: "编号",
          sortable: "custom"
        }, {
          default: _withId((scope) => [
            _createVNode("div", null, [
              _createVNode(_component_router_link, {
                to: {
              name: '工单详情',
              params: {
                id: scope.row.id
              }
            }
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(scope.row.id), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "标题",
          "show-overflow-tooltip": "",
          width: "180"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.$router.push({
              name: '工单详情',
              params: {
                id: scope.row.id
              }
            })),
                class: "title"
              }, [
                (scope.row.sourceType === 'task')
                  ? (_openBlock(), _createBlock("i", _hoisted_3))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'warning')
                  ? (_openBlock(), _createBlock("i", _hoisted_4))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'after_sale')
                  ? (_openBlock(), _createBlock("i", _hoisted_5))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'test')
                  ? (_openBlock(), _createBlock("i", _hoisted_6))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(scope.row.title), 1)
              ], 8, ["onClick"]),
              (scope.row.warning)
                ? (_openBlock(), _createBlock("span", _hoisted_7, "超时预警"))
                : _createCommentVNode("", true),
              (scope.row.timeout)
                ? (_openBlock(), _createBlock("span", _hoisted_8, "已超时"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "描述"
        }, {
          default: _withId((scope) => [
            (scope.row.desc)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  placement: "top"
                }, {
                  content: _withId(() => [
                    _createVNode("div", {
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  default: _withId(() => [
                    _createVNode("div", {
                      class: "ticket-desc",
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "curPhase",
          width: "90",
          label: "阶段",
          sortable: "custom"
        }, {
          default: _withId(({ row }) => [
            (row.curPhaseId)
              ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(row.curPhase), 1))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList((row.curPhases?.map(v => v.phaseName) || []), (v, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, _toDisplayString(v), 1))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "urgentLevel",
          width: "110",
          label: "紧急程度",
          sortable: "custom",
          formatter: _ctx.priorityFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          label: "创建时间",
          sortable: "custom",
          width: "120",
          formatter: _ctx.createTimeFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "operation",
          width: "120",
          label: "操作"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                class: "operation-btn",
                type: "text",
                onClick: ($event: any) => (_ctx.ticketClickAssign(scope.row))
              }, {
                default: _withId(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "default-sort", "onSelectionChange", "onSortChange"]), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.selectedTickets.length > 0 || _ctx.selectedTicketCurPage.length > 0)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showBatchProcess && _ctx.showBatchProcess(...args))),
          class: "batch-btn",
          "data-track-click": JSON.stringify({
           category: '工单视图-批量指派工单',
           action: '点击',
         })
        }, "批量指派工单", 8, ["data-track-click"]))
      : (_openBlock(), _createBlock("div", _hoisted_12, "批量指派工单")),
    (_ctx.total)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode(_component_el_pagination, {
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            "current-page": _ctx.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _ctx.pageSize,
            layout: "prev, pager, next, sizes, jumper, total",
            total: _ctx.total
          }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      "model-value": _ctx.showPersonSelectDialog,
      "show-close": false,
      "destroy-on-close": "",
      width: 400,
      "custom-class": "person-select-dialog"
    }, {
      default: _withId(() => [
        _createVNode(_component_PersonSelect, {
          cancel: _ctx.cancelPersonSelect,
          submit: _ctx.submitPersonSelect
        }, null, 8, ["cancel", "submit"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_el_dialog, {
      "model-value": _ctx.showBatchProcessDialog,
      "show-close": false,
      "destroy-on-close": "",
      width: 650,
      "custom-class": "handler-select-dialog"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_el_form, {
                model: _ctx.ruleForm,
                ref: "ruleFormRef",
                "label-position": "left",
                inline: true
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "下一阶段：",
                    prop: "nextProcess"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleForm.nextProcess,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ruleForm.nextProcess = $event)),
                        onChange: _ctx.changeNextProcess,
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processLabels, (l) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: l.id,
                              value: l.id,
                              label: l.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "处理人：",
                    prop: "nextHandler"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        clearable: "",
                        modelValue: _ctx.ruleForm.nextHandler,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ruleForm.nextHandler = $event)),
                        placeholder: "请选择",
                        filterable: ""
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.handlers, (p) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: p.id,
                              value: p.ldap,
                              label: p.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_el_button, { onClick: _ctx.cancelBatchProcess }, {
              default: _withId(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "success",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.proceedBatchProcess(_ctx.ruleFormData)))
            }, {
              default: _withId(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_EdgePersonSelect, {
      visible: _ctx.showEdgePersonSelectDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEdgePersonSelectDialog = $event)),
      "phase-list": (_ctx.ticketRowClicked?.curPhases || []).filter(s => !s.responsibleAgent),
      onAssign: _ctx.multiPersonSelect
    }, null, 8, ["visible", "phase-list", "onAssign"])
  ]))
})